<template>
  <div class="m-link">
    <template v-if="to">
      <a
        v-if="$fun.ifHttpUrl(to) || blank"
        :href="to"
        :target="blank ? '_blank' : ''"
        class="m-link-a"
      >
        <slot></slot>
      </a>
      <router-link :to="to" v-else class="m-link-a">
        <slot></slot>
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    to: {
      default: ""
    },
    blank: {
      default: false
    }
  },
  components: {},
  mounted() {},
  methods: {}
};
</script>
<style lang="less"></style>
